import './Banner.css'

function Banner() {
    return(
        <header className="banner">    
            <img src="/images/banner.png" alt="Banner principal"/>
        </header>
    )
}

export default Banner